/** Konfig pre nastavenie rychlosti hraca */
export const speedConfig = {

  /** Zakladna startovacia rychlost v m/s */
  startSpeedBase: 4,

  /** Koeficient pre startovaciu rychlost */
  startSpeedCoef: 1,

  /** Akceleracne koeficienty */
  acceleration: {

    /** Koeficienty pre silu do 1000 */
    strengthLowBase: 0.095,
    strengthLowCoef: 0.05,

    /** Koeficienty pre silu nad 1000 */
    strengthHighBase: 0.145,
    strengthHighCoef: 0.03

  },

  /** Koeficient spomalenia po naraze */
  slowDownCoefAfterImpact: 0.99,

  /** Zakladna forward force, ktorou zrychlujeme boby */
  forwardForceBase: 0.03,

  /** Koeficient pre forward force */
  forwardForceCoef: 0.01,

  /** Znasobovac povodnych sil pri starte */
  forwardForceMultiplier: 1.1,

  /** Backward force ktorym spomalujeme boby */
  backwardForce: -0.05

}
